import * as React from "react";
import classNames from "classnames";
import Title from "~/components/title/title";
import ImageTextCtaListItem, {
    ImageTextCtaListItemProps
} from "./image-text-cta-list-item/image-text-cta-list-item";
import { ThemeColorType } from "~/types/theme-color";
import { generateColumnImageProps } from "~/utils/image-utils";
import ContentSection from "../content-section/content-section";

export interface ImageTextCtaListProps {
    title?: string;
    isTitleH1?: boolean;
    maxColumns?: number;
    isFullWidth?: boolean;
    imageTextCtaList?: Array<ImageTextCtaListItemProps>;
    bgColor?: ThemeColorType;
    textColor?: ThemeColorType;
    showCtaAsLinkColor?: ThemeColorType; // Can be converted to ctaTextColor later, if Gyldendal want cta-colors to be configurable
    anchorId?: string;
    hasNoMarginTop?: boolean;
    hasNoMarginBottom?: boolean;
}

const ImageTextCtaList = ({
    title,
    isTitleH1,
    imageTextCtaList,
    maxColumns = 3,
    isFullWidth = false,
    bgColor,
    textColor,
    showCtaAsLinkColor,
    ...props
}: ImageTextCtaListProps) => {
    const baseClass = "image-text-cta-list";
    const componentClasses = classNames(baseClass, `config-columns config-columns--columns-${maxColumns}`, {
        [`${baseClass}--full-width`]: isFullWidth
    });
    const columnImageProps = generateColumnImageProps(maxColumns, isFullWidth);

    return (
        <ContentSection {...props} className={componentClasses}>
            <div className={`${baseClass}__inner`}>
                {title && <Title title={title} isTitleH1={isTitleH1} />}

                {imageTextCtaList && (
                    <div className={`${baseClass}__items`}>
                        {imageTextCtaList.map((item, index) => (
                            <ImageTextCtaListItem
                                key={index}
                                {...item}
                                {...columnImageProps}
                                bgColor={item.bgColor || bgColor}
                                textColor={item.textColor || textColor}
                                showCtaAsLinkColor={item.showCtaAsLinkColor || showCtaAsLinkColor}
                            />
                        ))}
                    </div>
                )}
            </div>
        </ContentSection>
    );
};

export default ImageTextCtaList;
